import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as BookingService from '_services/booking-service';

const initialState = {
    listCount: null,
    status: 'idle',
    error: null
};

// get all count
export const getListCount = createAsyncThunk('listCount/getListCount', async (params) => {
    return BookingService.getListCount(params);
});

const listCountSlice = createSlice({
  name: 'listCount',
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: {
    [getListCount.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
      }
    },
    [getListCount.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        listCount: action.payload,
      }
    },
    [getListCount.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        error: action.error.message,
      }
    },
  }
});

export const { reset } = listCountSlice.actions;
export const selectListCount = state => state.listCount.listCount;
export const selectListCountStatus = state => state.listCount.status;
export const listCountError = state => state.listCount.error;
export default listCountSlice.reducer;
